import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getDetails } from "../Redux/Action/SubAdmin";

const ModuleGuard = ({ children, modulePath }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { admindetails } = useSelector((state) => state.SubAdmin);
  const authentication = localStorage.getItem("authorization");
  const [showRetry, setShowRetry] = useState(false);

  useEffect(() => {
    if (authentication && !admindetails) {
      dispatch(getDetails());
      
      const timer = setTimeout(() => {
        setShowRetry(true);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [dispatch, authentication, admindetails]);

  if (!authentication) {
    return <Navigate to="/" />;
  }

  const handleRetry = () => {
    setShowRetry(false);
    dispatch(getDetails());
  };

  // While loading details, show nothing or a loader
  if (!admindetails) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        backgroundColor: '#f8fafc'
      }}>
        {!showRetry ? (
          <>
            <div className="spinner-border text-emerald-600" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <div style={{ marginTop: '20px', fontSize: '1.1rem', color: '#64748b', fontWeight: '500' }}>
              Verifying Permissions...
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ color: '#ef4444', marginBottom: '16px', fontSize: '1.1rem' }}>
              Verification is taking longer than expected.
            </div>
            <button 
              onClick={handleRetry}
              style={{
                backgroundColor: '#059669',
                color: 'white',
                padding: '10px 24px',
                borderRadius: '8px',
                border: 'none',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#047857'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#059669'}
            >
              Retry Verification
            </button>
          </div>
        )}
      </div>
    );
  }

  // Super Admin (Admin role) has access to everything
  if (admindetails.role === "Admin") {
    return children;
  }

  // Dashboard is accessible to all logged in admins
  if (modulePath === "/dashboard") {
    return children;
  }

  // Check if the current module path exists in the user's permissions
  const hasPermission = admindetails.permission?.some(
    (perm) => perm.url === modulePath || location.pathname === perm.url
  );

  if (!hasPermission) {
    console.warn(`Access denied for module: ${modulePath}`);
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ModuleGuard;
